import React, { Fragment, useContext, useState, useEffect, useRef } from 'react';

import Marquee from 'react-fast-marquee';

import { connect } from 'react-redux'
import store from 'store'
import { useNavigate, useLocation } from 'react-router-dom';

import { PiWarningDuotone, PiTerminalWindowDuotone } from "react-icons/pi";
/*
| UI
*/
import Flex from '../../../common/Flex';
import ProfileDropdown from '../../ProfileDropdown';

/*
| ICONS
*/
import { PiListBulletsDuotone, PiListBold } from "react-icons/pi";

/*
| PAGES
*/
import AppContext from 'context/Context';
/*
| IMAGES
*/
import Logo from '../../Logo';
import VarexeLogo from 'components/common/VarexeLogo';

import { Layout, Input, Menu, Dropdown, Button, Space, Select, Alert, Typography, Tag, Popconfirm, message, Modal, Skeleton } from "antd";
import { SearchOutlined, GlobalOutlined, GithubOutlined, SettingOutlined } from "@ant-design/icons";

import api from '../../../../services/api/';

const { Header } = Layout;
const { Option } = Select;

const mapStateToProps = ({ settings, auth }) => ({
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
})

const NavbarTopDeveloperMode = ({
  dispatch,
  isMenuCollapsed,
  isMobileView
}) => {
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteTestData = () => {
    setIsDeleting(true);
    api.delete('/developers/cleanup_test_data').then((response) => {
      const result = response.data;
      if (result.status === 200) {
        message.success(result.message);
        // Refresh the page after successful deletion
        window.location.reload();
      } else {
        message.error(result.message);
        setIsDeleting(false);
      }
    }).catch((err) => {
      console.log(err);
      message.error('Failed to delete test data');
      setIsDeleting(false);
    });
  }

  const {
    config: { isDark }
  } = useContext(AppContext);
  const { Text } = Typography;

  return (
    <Fragment>
      {/* FAAD14 */}
      <div className='px-2 py-1 w-100' style={{ backgroundColor: isDark ? "#FAAD14" : "#FAAD14", display: "flex" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Text className='text-white' strong></Text>
          {/* <Tag
            icon={<PiTerminalWindowDuotone size={18} />}
            bordered={false}
            color="warning"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          > */}
            <Text className='ms-1 text-white me-2' strong><PiTerminalWindowDuotone size={20} /> Test Mode</Text>
          {/* </Tag> */}
          <Popconfirm
            placement="topLeft"
            title="Delete All Test Data"
            description="Are you sure you want to delete all test data?"
            okText="Delete"
            okType="danger"
            onConfirm={deleteTestData}
          >
            <Button size="small" type="primary" danger>Delete test data</Button>
          </Popconfirm>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        </div>
      </div>

      <Modal
        open={isDeleting}
        footer={null}
        closable={false}
        mask={{ closable: false }}
        centered
        width={400}
      >
        <div style={{ padding: '20px' }}>
          <Skeleton active paragraph={{ rows: 2 }} />
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Text strong>Deleting test data...</Text>
            <br />
            <Text type="secondary">Please wait while we clean up the test data</Text>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
};

export default connect(mapStateToProps)(NavbarTopDeveloperMode)
